class ProductCardSwatches extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#onActivate);
    this.addEventListener('keydown', this.#onKeydown);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onActivate);
    this.removeEventListener('keydown', this.#onKeydown);
  }

  // Clic sur une pastille : on change l'image de la carte, sans quitter la page.
  // Le clic sur l'image (ou le reste de la carte) ouvre toujours la fiche produit.
  #onActivate = (e) => {
    const swatch = e.target.closest('.swatch-link');
    if (!swatch || !this.contains(swatch)) return;

    e.preventDefault();
    e.stopPropagation();

    this.#select(swatch);
    this.#updateImage(swatch);
  };

  // Accessibilité clavier : Entrée ou Espace sur une pastille
  #onKeydown = (e) => {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    this.#onActivate(e);
  };

  #select(swatch) {
    this.querySelectorAll('.swatch-link').forEach((el) => {
      if (el === swatch) {
        el.setAttribute('aria-checked', 'true');
      } else {
        el.removeAttribute('aria-checked');
      }
    });
  }

  #updateImage(swatch) {
    const src = swatch.dataset.imageSrc;
    if (!src) return;

    const scope = this.closest('product-card') || this.parentElement;
    const img = scope?.querySelector('product-card-media-gallery .product-media img');
    if (!img || img.getAttribute('src') === src) return;

    const srcset = swatch.dataset.imageSrcset;
    const alt = swatch.dataset.imageAlt;

    const apply = () => {
      if (srcset) img.srcset = srcset;
      img.src = src;
      if (alt) img.alt = alt;
    };

    // On précharge l'image pour éviter un clignotement
    const preload = new Image();
    preload.onload = apply;
    preload.onerror = apply;
    preload.src = src;
  }
}

if (!customElements.get('product-card-swatches')) {
  customElements.define('product-card-swatches', ProductCardSwatches);
}
